import React from 'react';
import { formatoCuentaRegresiva } from './formatoCuentaRegresiva';
import { elToast } from './alertas';

export default class CuentaRegresivaExamen extends React.Component {
  
  constructor(props) {

    super(props);
    this.state = {
      cuenta: 4800 // TIEMPO DE CUENTA REGRESIVA (1h 20m)
    }

  }

  //componente para ir disminuyendo la cuenta que ya fue renderizada en la vista
  componentDidMount() {

    this.timer = setInterval(() => {
      let { cuenta } = this.state;

      this.setState({
        cuenta: cuenta - 1
      })

    }, 1000) //se ejecutará cada 1000 milisegundos (1 segundo)

  }


  
  //componente para comparar el estado previo del objeto "cuenta" con su estado actual
  componentDidUpdate(prevProps, prevState, snapshot) {
    
    //si la cuenta ha llegado a 15 minutos, notificar al usuario
    if (prevState.cuenta !== this.state.cuenta && this.state.cuenta === 900) {
      
      elToast("Ha pasado 1 hora con 5 minutos, aún te quedan 15 minutos disponibles.", 'nada');

      
    } //si la cuenta ha llegado a 0...
    else if (prevState.cuenta !== this.state.cuenta && this.state.cuenta === 0) {
      
      clearInterval(this.timer);
      
      this.props.cuentaRegresivaTerminada();

    }

  }

  
  render(){

    let { cuenta } = this.state;

    return (
      <div>
        { formatoCuentaRegresiva(cuenta) }
      </div>
    )
  }
  
}
